import React from 'react';
import type { Direction } from '@wix/editor-elements-common-utils';
import type { MenuItemProps } from '@wix/editor-elements-definitions';
import type { IMenuItemSDKAction } from '@wix/editor-elements-corvid-utils';
import type { AnimationState } from '../MenuItem/useAnimationState';
import type { DropdownAnimationNameType } from '../../../Menu.types';
import { Dropdown } from '../Dropdown';
import { MenuItemContext } from '../../../../../common/menu/MenuItemContext';
import classes from '../MenuItem/style/MenuItem.module.scss';

export type HorizontalDropdownProps = {
  onEscKeyDown: () => void;
  item: MenuItemProps;
  currentItem?: MenuItemProps;
  children?: React.ReactNode;
  dropdownAnimationState: AnimationState<DropdownAnimationNameType>;
  direction?: Direction;
  itemClassName?: string;
  subItemClassName?: string;
  onItemClick?: IMenuItemSDKAction;
  onItemMouseIn?: IMenuItemSDKAction;
  onItemMouseOut?: IMenuItemSDKAction;
  onItemDblClick?: IMenuItemSDKAction;
};

export const HorizontalDropdown = (props: HorizontalDropdownProps) => {
  return (
    <MenuItemContext.Provider
      value={{
        onEscKeyDown: props.onEscKeyDown,
        item: props.item,
        currentItem: props.currentItem,
        dropdownAnimationState: props.dropdownAnimationState,
      }}
    >
      <Dropdown
        className={classes.horizontalDropdownDisplayWrapper}
        children={props.children}
        item={props.item}
        menuOrientation="horizontal"
        onItemClick={props.onItemClick}
        onItemMouseIn={props.onItemMouseIn}
        onItemMouseOut={props.onItemMouseOut}
        onItemDblClick={props.onItemDblClick}
      />
    </MenuItemContext.Provider>
  );
};
